import { ArrowLeft, Home } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button, Result } from 'antd'
import { useTranslations } from '@/lib/i18n/hooks'

export default function NotFoundPage() {
  const navigate = useNavigate()
  const t = useTranslations('errors')

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <Result
        status="404"
        title="404"
        subTitle={t('notFound')}
        extra={
          <div className="flex justify-center gap-3">
            <Button icon={<ArrowLeft className="h-4 w-4" />} onClick={() => navigate(-1)}>
              {t('goBack')}
            </Button>
            <Button type="primary" icon={<Home className="h-4 w-4" />} onClick={() => navigate('/activities')}>
              {t('goHome')}
            </Button>
          </div>
        }
      />
    </div>
  )
}
